import { Injectable } from '@angular/core';
import { LocalStorageService } from '@df/browser/storage/local-storage.service';
import { ProductResource } from '@df/catalog/product/product.resource';
import { Sample } from './sample';
@Injectable({
    providedIn: 'root'
})
export class SampleFactory {
    constructor(private productResource: ProductResource, private localStorageService: LocalStorageService) { }
    create(sampleId: number): Sample {
        return new Sample(sampleId, this.productResource, this.localStorageService);
    }
}
